import styled from 'styled-components';

export const EmailTextHeader = styled.h3`
  color: #283618;
`;

export const EmailHiddenText = styled.span`
  color: #283618;
  font-size: 14px;
  font-weight: 800;
`;
